import React from 'react';
import { Capacitor } from '@capacitor/core';
import './PermissionsPromptModal.scss';
import faceIcon from '../images/face-icon.svg';
import { FaBell } from 'react-icons/fa';

function PermissionsPromptModal({ 
  showNotificationPrompt, 
  showBiometricPrompt, 
  notificationDenied,
  onEnableNotifications, 
  onEnableBiometric, 
  onOpenSettings,
  onCheckAgain,
  onSkip, 
  onClose 
}) {
  // Debug log to track state changes
  React.useEffect(() => {
    console.log('[PermissionsModal] notificationDenied changed:', notificationDenied);
    console.log('[PermissionsModal] showNotificationPrompt:', showNotificationPrompt);
  }, [notificationDenied, showNotificationPrompt]);

  // Prevent focus issues
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const hasBothPrompts = showNotificationPrompt && showBiometricPrompt;
  const hasAnyPrompt = showNotificationPrompt || showBiometricPrompt;

  if (!hasAnyPrompt) {
    return null;
  }

  return (
    <div 
      className="modal-overlay permissions-modal-overlay" 
      onClick={handleOverlayClick}
      onMouseDown={(e) => e.preventDefault()}
    >
      <div 
        className="modal permissions-prompt-modal" 
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="permissions-list">
            {showNotificationPrompt && (
              <div className="permission-item">
                <div className="permission-icon notification-icon">
                  <FaBell />
                </div>
                <div className="permission-info">
                  <h3>Push Notifications</h3>
                  {notificationDenied ? (
                    <>
                      <p className="important-message">
                        <strong>It's important you enable Push Notifications</strong> so you don't miss out on updates such as:
                      </p>
                      <ul className="notification-benefits">
                        <li>Team selection notifications</li>
                        <li>Match updates and reminders</li>
                        <li>Training session changes</li>
                        <li>Important team announcements</li>
                      </ul>
                      <p className="settings-instruction">
                        Please enable notifications in your device Settings.
                      </p>
                    </>
                  ) : (
                    <p>Get notified about matches, training sessions, and important updates</p>
                  )}
                </div>
                {notificationDenied ? (
                  <div className="denied-buttons">
                    <button 
                      onClick={onOpenSettings} 
                      className="enable-btn settings-btn"
                      onFocus={(e) => e.target.style.outline = 'none'}
                    >
                      Open Settings
                    </button>
                    <button 
                      onClick={onCheckAgain} 
                      className="enable-btn check-again-btn"
                      onFocus={(e) => e.target.style.outline = 'none'}
                    >
                      I've Enabled Notifications
                    </button>
                  </div>
                ) : (
                  <button 
                    onClick={onEnableNotifications} 
                    className="enable-btn"
                    onFocus={(e) => e.target.style.outline = 'none'}
                  >
                    Enable
                  </button>
                )}
              </div>
            )}

            {showBiometricPrompt && (
              <div className="permission-item">
                <div className="permission-icon biometric-icon">
                  <img src={faceIcon} alt="Face ID" />
                </div>
                <div className="permission-info">
                  <h3>Face ID Login</h3>
                  <p>Sign in quickly and securely with Face ID</p>
                </div>
                <button 
                  onClick={onEnableBiometric} 
                  className="enable-btn"
                  onFocus={(e) => e.target.style.outline = 'none'}
                >
                  Enable
                </button>
              </div>
            )}
          </div>

          <div className="modal-buttons">
            <button 
              onClick={onSkip} 
              className="secondary-btn skip-btn"
              onFocus={(e) => e.target.style.outline = 'none'}
            >
              Skip for Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PermissionsPromptModal;

